export const emptyEstatesState = {
  list: [],
  meta: { currentPage: 1, lastPage: 1, total: 0 },
  loading: false,
  saving: false,
}
